import { Component, ViewChild, ElementRef } from '@angular/core';
import { ViewEncapsulation } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { AppService } from './app.service';
import { PdfBuilderService } from './shared/pdfBuilder.service';

import { AppConstants } from './app.constants';
import { TitleSection } from './shared/constants/titleSection.constant';
import { ExtColors } from './shared/constants/extColors.constant';
import { InsideProps } from './shared/constants/insideProps.constant';
import { Models } from './shared/constants/models.constant';
import { Cromados } from './shared/constants/cromados.constant';
import { InsideColors } from './shared/constants/insideColors.constant';
import { Complements } from './shared/constants/complements.constant';
import { LockerStatus } from './shared/constants/LockerStatus.constant';

import { environment } from '../environments/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class AppComponent {
    public modelosArray: Array<any>;
    public cromados: Array<any>;
    public insideColorsArray: Array<any>;
    public insidePropsArray: Array<any>;
    public currentInsidePropsArray: Array<any>;
    public complementsArray: Array<any>;
    public currentComplementsArray: Array<any>;
    public watchShelvesArray: Array<any>;
    public glassShelvesArray: Array<any>;
    public selectedModelo: any;
    public extColorsArray: Array<any>;
    public accesoriesArray: Array<any>;
    public selectedColorExterior: any;
    public selectedColorInterior: any;
    public selectedCromado: any;
    public selectedAccessory: any;
    public shelvesArray: Array<any>;
    public numBigShelves: number = 0;
    public numSmallShelves: number = 0;
    public numWatchShelves: number = 0;
    public numUsbShelves: number = 0;
    public numGlassShelves: number = 0;
    public maxNumGlassShelves: number;
    public availableSpace: number;
    public titleSection: any;
    public lockerStatusArray: Array<any>;
    public selectedStatus: any;
    public showModal: boolean = false;
    public glassShelvesPosition: Array<any>;
    private oldselectedModelo: any;
    private selectedComplement: any;
    private oldInteriorColor: any;
    private modelGlassShelves: number = 0;    
    private environment: any;
    private dropdownSettings: Object;
    private selectedItems:Array<any>;

    @ViewChild('footerForm') footerForm: ElementRef;
    @ViewChild('lockContainer') lockContainer: ElementRef;

    constructor(private appService: AppService, private pdfBuilderService: PdfBuilderService) {
        this.shelvesArray = [];
        this.accesoriesArray = [];
        this.watchShelvesArray = [];
        this.glassShelvesArray = [];
        this.titleSection = TitleSection;
        this.insidePropsArray  = InsideProps;
        this.currentInsidePropsArray = InsideProps;
        this.selectedAccessory = this.insidePropsArray[0];
        this.modelosArray = Models;
        this.selectedModelo = this.modelosArray[7];
        this.oldselectedModelo = this.selectedModelo;
        this.cromados = Cromados;
        this.selectedCromado = this.cromados[0];
        this.insideColorsArray = InsideColors;
        this.selectedColorInterior = this.insideColorsArray[0];
        this.complementsArray = Complements;
        this.selectedComplement = this.complementsArray[1];
        this.extColorsArray = ExtColors;
        this.selectedColorExterior = this.extColorsArray[0];
        this.lockerStatusArray = LockerStatus;
        this.selectedStatus = this.lockerStatusArray[0];
        this.glassShelvesPosition = [];
        this.environment = environment;
        this.maxNumGlassShelves = 0;
        this.availableSpace = this.selectedModelo.size - 1;
        this.accessoriesModel();
        this.complementsAccesories();
    }

    /**
    * L'usuari ha seleccionat un model de caixa forta.
    */
    public OpenLockerChangeDialog(){
        if (this.selectedModelo != this.oldselectedModelo && this.accesoriesArray.length > 0) {
            const body = document.getElementsByTagName('body')[0];
            body.classList.add('modal-open');
            body.scrollIntoView();
            this.showModal = true;
        }
        this.accessoriesModel();
    }

    /**
    * L'usuari ha seleccionat un color interior.
    */
    public changeInteriorColor() {
        let auxShelvesArray = this.shelvesArray;
        let auxWatchShelvesArray = this.watchShelvesArray;
        this.shelvesArray = this.appService.changeIntColor(auxShelvesArray, this.oldInteriorColor, this.selectedColorInterior);
        this.watchShelvesArray = this.appService.changeIntColor(auxWatchShelvesArray, this.oldInteriorColor, this.selectedColorInterior);;
        this.oldInteriorColor = this.selectedColorInterior;
    }

    /**
    * L'usuari ha seleccionat un complement.
    */
    public getComplement(item) {
        this.selectedComplement = item;
    }

    /**
    * L'usuari ha seleccionat un nombre de lleixes de vidre.
    */
    public changeGlassShelves(){
        if( this.modelGlassShelves > this.maxNumGlassShelves){
            this.modelGlassShelves = this.maxNumGlassShelves;
        }
    }

     /**
    * Afegeix un accessori (IX0A/IX02A, IX0B/IX02B, IX0C/IX02C, IX0D, IX0E/IX02E).
    *
    * @param {type}   color     Color interior seleccionat.
    */   
    public addAccessory(color) {
        this.oldInteriorColor = color;

        if (this.selectedAccessory.code === AppConstants.BIG_SHELVES_CODE || this.selectedAccessory.code === AppConstants.BIG_SHELVES_CODE2) {
            this.addBigShelve(color);
        }
        if (this.selectedAccessory.code === AppConstants.SMALL_SHELVES_CODE || this.selectedAccessory.code === AppConstants.SMALL_SHELVES_CODE2) {
            this.addSmallShelve(color);
        }
        if (this.selectedAccessory.code === AppConstants.GLASS_SHELVES_CODE || this.selectedAccessory.code === AppConstants.GLASS_SHELVES_CODE2) {
            this.addGlassShelve();
        }
        if (this.selectedAccessory.code === AppConstants.WATCH_SHELVES_CODE || this.selectedAccessory.code === AppConstants.WATCH_SHELVES_CODE2) {
            this.addWatchShelve(color);
        }
        if (this.selectedAccessory.code === AppConstants.USB_SHELVES_CODE) {
            this.addUSBShelve();
	}

        this.accesoriesArray.sort((acc1,acc2) => (acc1.code > acc2.code) ? 1 : ((acc2.code > acc1.code) ? -1 : 0));

        this.checkSizeLocker();
    }

    /**
    * Afegeix un accessori IX0B: Cajón alto.
    *
    * @param {type}   color              Color seleccionat.
    *
    * Los cajones se insertan por abajo
    * Los cajones altos se colocan siempre debajo de los bajos
    */ 
    private addBigShelve(color) {
        const bigShelveImg = {
            imgURL: AppConstants.INT_IMAGES_URL + color.code + '_' + color.url + '/' + this.selectedAccessory.code + '_' + color.code + '.png',
            imgALT: this.selectedAccessory.code + '_' + color.code
        };
        let itemToPush = Object.assign({}, this.selectedAccessory);
        itemToPush.complement = [];
        itemToPush.complement.push(this.selectedComplement);
        this.numBigShelves += this.selectedAccessory.size;
        this.shelvesArray.push(bigShelveImg);
        this.accesoriesArray.push(itemToPush);
    }

    /**
    * Afegeix un accessori IX0A: Cajón bajo.
    *
    * @param {type}   color              Color seleccionat.
    *
    * Los cajones se insertan por abajo
    * Los cajones altos se colocan siempre debajo de los bajos
    */ 
    private addSmallShelve(color) {
        const smallShelveImg = {
            imgURL: AppConstants.INT_IMAGES_URL + color.code + '_' + color.url + '/' + this.selectedAccessory.code + '_' + color.code + '.png',
            imgALT: this.selectedAccessory.code + '_' + color.code
        };
        let itemToPush = Object.assign({}, this.selectedAccessory);
        itemToPush.complement = [];
        itemToPush.complement.push(this.selectedComplement);
        this.numSmallShelves += this.selectedAccessory.size;

        if (this.numUsbShelves > 0) {
            // Si hi ha un IX0D, col·loquem l'IX0A just després.
            this.shelvesArray.splice(1, 0, smallShelveImg);
        } else {
            this.shelvesArray.unshift(smallShelveImg);
        }
        this.accesoriesArray.push(itemToPush);
    }

    /**
    * Afegeix un accessori IX0C: Relojero.
    *
    * @param {type}   color              Color seleccionat.
    *
    * Los relojeros se insertan siempre por arriba
    * Siempre tiene que haber, en la parte superior:
    *   o bien un IX0I/IX02I - Compartimiento para conexiones,
    *   o bien un relojero (ya que incluye el compartimiento para conexiones)
    * Al eliminar pues el último relojero, hay que añadir de nuevo el IX0I/IX02I.
    */  
    private addWatchShelve(color) {
        const watchShelveImg = {
            imgURL: AppConstants.INT_IMAGES_URL + color.code + '_' + color.url + '/' + this.selectedAccessory.code + '_' + color.code + '.png',
            imgALT: this.selectedAccessory.code + '_' + color.code
        };
        this.numWatchShelves += this.selectedAccessory.size;
        this.watchShelvesArray.push(watchShelveImg);
        this.accesoriesArray.push(this.selectedAccessory);
    }

    /**
    * Afegeix un accessori IX0D: Tomas de energía y carga USB.
    *
    * El accesorio IX0D - Tomas de energía y carga USB se coloca justo encima del cajón superior, a modo de tapa. 
    *   Si no hay cajones, no se puede insertar (error #E02).
    *   Si no hay por lo menos dos espacios libres por encima del cajón, no se puede insertar (error #E01).
    *   Al eliminar el último cajón, hay que eliminar también este accesorio.
    *   Sólo se puede insertar uno (error #E03)
    * Este accesorio no se puede colocar en los modelos AR-2 ni AP-2.
    */  
    private addUSBShelve() {
        const usbShelveImg = {
            imgURL: AppConstants.INT_IMAGES_URL + AppConstants.SEPARATOR_SHELVE_CODE + '.png',
            imgALT: AppConstants.SEPARATOR_SHELVE_CODE
        };

        // Si hi ha almenys un calaix, l'afegim a mode de tapa.
        if(this.numUsbShelves === 0 && (this.numBigShelves > 0 || this.numSmallShelves > 0)) {
            if (!this.accesoriesArray.includes(this.selectedAccessory)) {
                this.shelvesArray.unshift(usbShelveImg);
                this.accesoriesArray.push(this.selectedAccessory);
            }
            // Ja no en podem afegir més.
            this.numUsbShelves += this.selectedAccessory.size;
            //console.log('this.numUsbShelves', this.numUsbShelves);
        }
    }

    /**
    * Afegeix un accessori IX0E: Estante de cristal.
    *
    * Los estantes de cristal se insertan todos de una sola vez en el hueco disponible.
    * El sistema (select) sólo permite insertar hasta h - 1 (donde h es el número de huecos disponibles) estantes.
    * El usuario escoge el número de estantes que quiere insertar y se insertan mediante el algoritmo descrito.
    */  
    private addGlassShelve() {
        const glassShelveImg = {
            imgURL: AppConstants.INT_IMAGES_URL + this.selectedAccessory.code + '.png',
            imgALT: this.selectedAccessory.code,
            position:0
        };
        for (let x = 0; x < this.modelGlassShelves; x++) {
            this.numGlassShelves = this.numGlassShelves + this.selectedAccessory.size;
            this.glassShelvesArray.push(glassShelveImg);
            this.accesoriesArray.push(this.selectedAccessory);
        }
        this.modelGlassShelves = 0;
    }

    /**
    * L'usuari ha eliminat un accessori.
    *
    * @param {type}   data
    */
    deleteAccesorie(data) {
        if (data.accesorie.code === AppConstants.BIG_SHELVES_CODE || data.accesorie.code === AppConstants.BIG_SHELVES_CODE2) {
            this.deleteBigShelve(data.accesorie);
        }
        if (data.accesorie.code === AppConstants.SMALL_SHELVES_CODE || data.accesorie.code === AppConstants.SMALL_SHELVES_CODE2) {
            this.deleteSmallShelve(data.accesorie);
        }
        if (data.accesorie.code === AppConstants.GLASS_SHELVES_CODE || data.accesorie.code === AppConstants.GLASS_SHELVES_CODE2) {
            this.deleteGlassShelve(data.accesorie);
        }
        if (data.accesorie.code === AppConstants.WATCH_SHELVES_CODE || data.accesorie.code === AppConstants.WATCH_SHELVES_CODE2) {
            this.deleteWatchShelve(data.accesorie);
        }
        if (data.accesorie.code === AppConstants.USB_SHELVES_CODE) {
            this.deleteUSBShelve();
        }

        this.accesoriesArray.splice(data.index, 1);

        if (data.accesorie.code === AppConstants.BIG_SHELVES_CODE || data.accesorie.code === AppConstants.BIG_SHELVES_CODE2 || data.accesorie.code === AppConstants.SMALL_SHELVES_CODE || data.accesorie.code === AppConstants.SMALL_SHELVES_CODE2) {
            // Acabem d'eliminar un calaix.
            // Si és el darrer calaix i hi havia un IX0D, l'eliminem també.
            if (this.numUsbShelves > 0 && this.numBigShelves === 0 && this.numSmallShelves === 0) {
                // Hi ha un IX0D i hem eliminat l'últim calaix => eliminem IX0D
                this.deleteUSBShelve();
                this.accesoriesArray = this.accesoriesArray.filter(function(acc) { return acc.code != AppConstants.USB_SHELVES_CODE });
            }
        }


        this.checkSizeLocker();
    }

    /**
    * Elimina un accessori IX0B: Cajón alto.
    * Al eliminar el último cajón, hay que eliminar también el accesorio IX0D, si existe.
    *
    * @param {type}   shelve        Accessori seleccionat.
    */
    private deleteBigShelve(shelve) {
        let count = 0;
        this.numBigShelves = this.numBigShelves - shelve.size;
        this.shelvesArray.map((data, i) => {
            if (data.imgALT.includes(shelve.code) && count === 0) {
                this.shelvesArray.splice(i, 1);
                // i !== 0 ? this.shelvesArray.splice((i - 1), 1) : this.shelvesArray.splice(0, 1);
                count = 1;
            }
        });
    }

    /**
    * Elimina un accessori IX0A: Cajón bajo.
    * Al eliminar el último cajón, hay que eliminar también el accesorio IX0D, si existe.
    *
    * @param {type}   shelve        Accessori seleccionat.
    */
    private deleteSmallShelve(shelve) {
        let count = 0;
	this.numSmallShelves -= shelve.size;
	this.shelvesArray.map((data, i) => {
            if (data.imgALT.includes(shelve.code) && count === 0) {
                this.shelvesArray.splice(i, 1);
                count = 1;
            }
	});
    }

    /**
    * Elimina un accessori IX0C: Relojero.
    *
    * @param {type}   shelve        Accessori seleccionat.
    */
    private deleteWatchShelve(shelve) {
	let count = 0;
	this.numWatchShelves -= shelve.size;
        this.watchShelvesArray.map((data, i) => {
            if (data.imgALT.includes(shelve.code) && count === 0) {
                this.watchShelvesArray.splice(i, 1);
                count = 1;
            }
        });
    }

    /**
    * Elimina l'accessori IX0D: Tomas de energía y carga USB.
    */ 
    private deleteUSBShelve() {
        let count = 0;
        this.shelvesArray.map((data, i) => {
            if (data.imgALT.includes(AppConstants.SEPARATOR_SHELVE_CODE) && count === 0) {
                this.shelvesArray.splice(i, 1);
                count = 1;
            }
        });
        // Ja en podem tornar a afegir.
        this.numUsbShelves = 0;
        //console.log('this.numUsbShelves', this.numUsbShelves);
    }

    /**
    * Elimina un accessori IX0E: Estante de cristal.
    *
    * @param {type}   shelve        Accessori seleccionat.
    */
    private deleteGlassShelve(shelve) {
        let count = 0;
        this.numGlassShelves = this.numGlassShelves - shelve.size;
        this.glassShelvesArray.map((data, i) => {
            if (data.imgALT.includes(shelve.code) && count === 0) {
                this.glassShelvesArray.splice(i, 1);
                count = 1;
            }
        });
    }

    /*
    * Actualitza la llista d'accessoris disponibles per al model seleccionat, i selecciona el primer per defecte.
    */
    private accessoriesModel(){
        var selmodel = this.selectedModelo.size;
        this.currentInsidePropsArray = this.insidePropsArray.filter(function(e){return e.lockerSize.includes( selmodel )});
        this.selectedAccessory = this.currentInsidePropsArray[0];
        this.complementsAccesories();
    }

    /**
    * Actualitza la llista de complements de l'accessori seleccionat, i selecciona el complement.
    */    
    private complementsAccesories(){
        var accCode = this.selectedAccessory.code;
        this.currentComplementsArray = this.complementsArray.filter(function(e) { return e.insideProps.includes(accCode) });

        if (!this.selectedComplement) {
            // Si no està establert el complement seleccionat, establim el primer de la llista de complements.            
            this.selectedComplement = this.currentComplementsArray[0];
        }
        else {
            var comCode = this.selectedComplement.code;
            if (!this.currentComplementsArray.some(e => e.code === comCode) ) {
                // Si el complement seleccionat no pertany a la llista de complements de l'accessori, establim el primer de la llista de complements.            
                this.selectedComplement = this.currentComplementsArray[0];
            }
        }
    }

    /**
    * L'usuari ha clicat un botó del modal.
    *
    * @param {boolean}   value        Continuar = true, Cancel·lar = false.
    */
    public confirmLockerChange(value) {
        if (value) {
            this.oldselectedModelo = this.selectedModelo
            this.accesoriesArray.length = 0
            this.watchShelvesArray.length = 0
            this.glassShelvesArray.length = 0
            this.watchShelvesArray.length = 0
            this.shelvesArray.length = 0
            this.numBigShelves = this.numSmallShelves = this.numWatchShelves = this.numGlassShelves = this.numUsbShelves = 0;
        } else {
            this.selectedModelo = this.oldselectedModelo;
        }
        const body = document.getElementsByTagName('body')[0];
        body.classList.remove('modal-open');
        this.showModal=false;
        this.checkSizeLocker();
    }


    /**
    * Fem una sèrie d'accions per deixar la caixa i els accessoris en un estat coherent.
    * - Llistem els complements de l'accessori seleccionat.
    * - Col.loquem les lleixes de vidre.
    * - this.maxNumGlassShelves: nombre màxim de lleixes de vidre que es poden col·locar.
    */
    public checkSizeLocker() {

        this.complementsAccesories();

        // Sumem tots els accessoris excepte les lleixes de vidre.
	let occupiedSpace = this.numBigShelves + this.numSmallShelves + this.numWatchShelves + this.numUsbShelves;
        //console.log('occupiedSpace', occupiedSpace);

        // Calculem l'espai disponibles del model de la caixa (sense comptar els accessoris); si hi ha la tapa de connexions (no hi ha rellotger), restem 1 espai.
        let modeloAvailableSpace = this.watchShelvesArray && this.watchShelvesArray.length > 0 ? (this.selectedModelo.value) : this.selectedModelo.value - 1;
        //console.log('modeloAvailableSpace', modeloAvailableSpace);

        // Calculem l'espai disponible a la caixa comptant els accessoris (excepte les lleixes de vidre, ja que en aquest punt encara les hem de col·locar).
        this.availableSpace = modeloAvailableSpace - occupiedSpace;
        //console.log('this.availableSpace', this.availableSpace);

        // Calculem el nombre màxim de lleixes de vidre que es poden col·locar; En podem col·locar tantes com espais hi hagin - 1.
        this.maxNumGlassShelves = (this.numUsbShelves > 0) ? this.availableSpace : this.availableSpace - 1;

        if (this.numGlassShelves > 0) {
            // Col·loquem les lleixes de vidre:
            //
            ////// FÓRMULA //////
            // factor = ⎡(h - 1) / (n + 1)⎤;
            // for (i=1; i<=n; i++) {
            //  col·loca a la guia i*factor; (si és més gran, fem el mòdul)
            // }

            // Calculem l'espai disponible sense comptar les lleixes de vidre que hi pugui haver.
            var h = this.numUsbShelves === 0 ? this.availableSpace : this.availableSpace + 1;  

            let factor = Math.ceil((h - 1) / (this.glassShelvesArray.length + 1));
            //console.log('factor', factor);
            //console.log('h', h);

            this.glassShelvesPosition = this.glassShelvesArray.map(function(glass, index ){
                //console.log('i', index + 1);
                let result;
                if (((index + 1) * factor) <= (h - 1)) {
                    result = (index + 1) * factor;
                }
                else {
                    // si i*factor > h-1, calculem el mòdul
                    result = ((index + 1) * factor) % (h - 1);
                }

                //console.log('result', result);
                return result;
            })

            ////// end FÓRMULA //////

            // Un cop col·locades, restem les lleixes de vidre a l'espai disponible.
            this.availableSpace = (this.numUsbShelves > 0) ? this.availableSpace - this.numGlassShelves : this.availableSpace - this.numGlassShelves - 1;
            //console.log('this.availableSpace (after placed Glass shelves)', this.availableSpace);
            this.maxNumGlassShelves = this.availableSpace;
            //console.log('this.maxNumGlassShelves (after placed Glass shelves)', this.maxNumGlassShelves);
        }

        //console.log('this.maxNumGlassShelves', this.maxNumGlassShelves);
    }

    /**
    * L'usuari ha clicat "Descargar PDF", o bé el Drupal ha llençat l'event de clic del botó ocult per generar el PDF en base64.
    * Creem el PDF amb la informació que hi ha a "Tu configuración"
    *
    * @param {boolean}   download     Indica si cal descarregar el fitxer o bé passar-lo al pare en base64.
    */
    downloadPdf(download: boolean) {
        const objectToPrint = {
            model: this.selectedModelo,
            extColorCode: this.selectedColorExterior.Number,
            extColorName: this.selectedColorExterior.Name,
            cromado: this.selectedCromado,
            intColor: this.selectedColorInterior,
            accesories: this.accesoriesArray
        }
        window.scrollTo(0, 0);
        this.pdfBuilderService.downloadPdf(this.lockContainer.nativeElement, objectToPrint, download);
    }

    /**
    * L'usuari ha clicat "Hacer pedido".
    * Fem scroll fins el formulari "Haz tu pedido".
    */
    public scrollToForm() {
        var element_to_scroll_to = window.parent.document.getElementById('haz_tu_pedido_webform');
        element_to_scroll_to.scrollIntoView({ behavior: 'smooth' });
    }
}
